import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { LoginActions } from './login.actions'
import { Router } from '@angular/router'

@Injectable()
export class LoginEffects {
  loginEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LoginActions.login),
      map(() => {
        // todo: implement validation etc.
        return LoginActions.loginSuccess()
      }),
      catchError(() => of(LoginActions.loginFailed())),
    )
  })

  loginSuccessEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(LoginActions.loginSuccess),
        tap(() => {
          this.router.navigateByUrl('/navigation')
        }),
      )
    },
    { dispatch: false },
  )

  constructor(private readonly actions$: Actions, private readonly router: Router) {}
}
